<template>
    <div :class="isMobile ? 'gain-m' : 'gain'">

      <!-- <div>
        <div class="word">
          <div class="word-title">核心团队</div>
          <div class="word-text">Core team</div>
        </div>
      </div>
      <div class="team-first-box" >
        <div class="team-first-one" v-for="(item, index) in teamlist" :key="index">
          <el-row>
            <el-col :span="isMobile?24:6">
              <div class="left-box">
                <div class="team-img-bg"></div>
                <img :src="item.url" class="team-user" />
                <div class="team-user-job-text">
                  <img :src="teambg" class="team-text-bg" />
                  <div class="team-text-con">{{ item.title }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="isMobile?24:18">
              <div class="right-box">
                <div class="job-box">
                  <div>{{ item.name }}</div>
                  <div>{{ item.job }}</div>
                </div>
                <div v-for="(obj, i) in item.text" :key="i" class="text-one">
                  {{ obj }}
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="long-light" v-if="index<teamlist.length-1"></div>
          
        </div>
      </div> -->

      <div>
        <div class="word">
          <div class="word-title">科研成果</div>
          <div class="word-text">Research Achievements</div>
        </div>
      </div>
      <div class="intel-box">
        <el-row>
          <el-col :span="6" v-for="(item, index) in intelList_01" :key="item.text" class="intel-one" >
            <div class="intel-one-con">
              <span class="intel-one-num" v-number-scroll="item.num" >1</span>
              <span class="intel-one-unit">{{ item.unit }}</span>
            </div>
            <div class="intel-one-text">
              {{ item.text }}
            </div>
          </el-col>
          <el-col :span="8" v-for="(item, index) in intelList_02" :key="item.text" class="intel-one" >
            <div class="intel-one-con">
              <span class="intel-one-num" v-number-scroll="item.num" >1</span>
              <span class="intel-one-unit">{{ item.unit }}</span>
            </div>
            <div class="intel-one-text">
              {{ item.text }}
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="intellectual">
        <div class="word">
          <div class="word-title">知识产权</div>
          <div class="word-text">Intellectual Property</div>
        </div>
        <div class="intellectual-content">
          <div class="bannerList">
            <div class="bannerList">
              <div class="intelswiper swiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, i) in intellectualList" :key="i">
                    <div class="swipperItem">
                      <img style="width: 100%;height: 100%;" :src="item.url" />
                      <div class="img-up-word">
                        <div class="img-up-word-content">{{item.title}}</div>
                        <!-- <div class="img-up-word-dec">{{item.date}}</div> -->
                      </div>
                    </div></div>
                </div>
                <div class="swiper-button-prev intel_prev"></div>
                <div class="swiper-button-next intel_next" ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intellectual">
        <div class="word">
          <div class="word-title">荣誉证书</div>
          <div class="word-text">Certificate of Honor</div>
        </div>
        <div class="intellectual-content">
          <div class="bannerList">
            <div class="bannerList">
              <div class="honorswiper swiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, i) in honorlist" :key="i">
                    <div class="swipperItem">
                      <img style="width: 100%;height: 100%;" :src="item.url" />
                      <div class="img-up-word">
                        <div class="img-up-word-content">{{item.title}}</div>
                        <!-- <div class="img-up-word-dec">{{item.date}}</div> -->
                      </div>
                    </div></div>
                </div>
                <div class="swiper-button-prev honor_prev"></div>
                <div class="swiper-button-next honor_next" ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </template>
  
  <script>
  import Swiper from "swiper";
  import "swiper/swiper.min.css"
  import imgUrl from "@/utils/imgUrl";
  import arrJson from '@/utils/arrJson';
  import { createNumberScrollDirective } from '@/utils/VueNumberScroll.js';

  export default {
    name: 'Gain',
    directives: {
      'number-scroll': createNumberScrollDirective({
        duration: 1200,
        easing: 'easeOut',
        separator: ',',
        once: false
      })
    },
    data() {
      return{
        isMobile: window.innerWidth < 780,
        teambg: imgUrl.teambg,
        intelList_01: [
          {
            num: 81,
            unit: "件",
            text: "发明专利"
          }, {
            num: 39,
            unit: "件",
            text: "授权专利"
          },{
            num: 28,
            unit: "项",
            text: "商标"
          }, {
            num: 11,
            unit: "项",
            text: "软著"
          }
        ],
        intelList_02: [{
            num: 2,
            unit: "件",
            text: "外观专利"
          },{
            num: 2,
            unit: "件",
            text: "国际专利(PCT)"
          },{
            num: 5,
            unit: "件",
            text: "实用新型"
          }
        ],
        intellectualList: arrJson.intellectualList,
        honorlist: arrJson.honorList,
        // abilitylist: arrJson.abilitylist,
        technologylist: arrJson.technologylist,
        teamlist: arrJson.teamlist,
        standList: [
          {
            num: 2,
            unit: "项",
            text: "企标"
          }, {
            num: 1,
            unit: "项",
            text: "国标"
          }, {
            num: 3,
            unit: "项",
            text: "团标"
          }
        ],
        serverList: [
          {
            num: 26,
            unit: "家",
            text: "服务企业"
          }, {
            num: 4,
            unit: "家",
            text: "学术机构"
          }, {
            num: 1,
            unit: "个",
            text: "政府部门"
          }
        ],
        areaList: [
          {
            text: "室内空气监测",
            img: imgUrl.area1
          }, {
            text: "消防监测",
            img: imgUrl.area2
          }, {
            text: "汽车电子",
            img: imgUrl.area3
          }, {
            text: "安全监控",
            img: imgUrl.area4
          }, {
            text: "空气净化器",
            img: imgUrl.area5
          }, {
            text: "环保监测",
            img: imgUrl.area6
          }, {
            text: "智慧城市",
            img: imgUrl.area7
          }, {
            text: "气味数字化",
            img: imgUrl.area8
          }
        ]
      }
    },
    props: {
      msg: String
    },
    mounted() {
      window.addEventListener("resize", this.initFunc)
      this.setSwiper()
    },
    methods: {
      initFunc() {
        this.isMobile = window.innerWidth < 780
      },
      setSwiper(){
        const t = this
        this.swiper1 = new Swiper('.intelswiper', {
          // pagination: {
          //   el: '.swiper-pagination-intellectual',
          //   clickable: true,
          // },
          // loop: true, // 是否循环，内容会两倍
          autoplay: {
            delay: 0,  // 切换间隔时间（毫秒）
            disableOnInteraction: false,  // 用户操作后是否停止自动播放
          },
          speed: 4000,
          clickable: true,
          slidesPerView: t.isMobile ? 2 : 5,
          navigation: {
            nextEl: '.intel_next',
            prevEl: '.intel_prev',
          },
        })
        this.swiper2 = new Swiper('.honorswiper', {
          // pagination: {
          //   el: '.swiper-pagination-intellectual',
          //   clickable: true,
          // },
          loop: true, // 是否循环，内容会两倍
          autoplay: {
            delay: 0,  // 切换间隔时间（毫秒）
            disableOnInteraction: false,  // 用户操作后是否停止自动播放
          },
          speed: 4000,
          clickable: true,
          slidesPerView: t.isMobile ? 2 : 3,
          navigation: {
            nextEl: '.honor_next',
            prevEl: '.honor_prev',
          },
        })
      }
    },
    destroyed() {
      window.removeEventListener("resize", this.initFunc)
    },
  }
  </script>
  
  
  <style scoped lang="less">
    .intelswiper{
      position: relative;
    }
    .honorswiper{
      position: relative;
    }
    .swipperItem .img-up-word{
      .img-up-word-content{
        text-align: center;
      }
    }
    .gain{
      .word{
        margin-top: 60px;
        .word-title{
          line-height: 34px;
          font-size: 32px;
          margin-top: 60px;
          font-weight: bold;
          color: #333333;
          letter-spacing: 2px;
          text-align: center;
        }
        .word-text{
          font-size: 16px;
          line-height: 26px;
          color: #758292 ;
          text-align: center;
        }
      }
      // .ability-box{
      //   width: 1400px;
      //   margin: 30px auto;
      //   .gray-box{
      //     border-radius: 10px;
      //     background-color: #F3F3F5;
      //     padding: 30px 30px;
      //     height: 178px;
      //     box-sizing: border-box;
      //     .ability-tit{
      //       font-size: 18px;
      //       line-height: 50px;
      //       font-weight: bold;
      //       .blue-text{
      //         color: #10D2FE;
      //         font-size: 40px;
      //         font-weight: normal;
      //       }
      //     }
      //     .ability-text{
      //       color: #989898;
      //       font-size: 16px;
      //       line-height: 20px;
      //     }
      //   }
      // }
      .tech-box{
        max-width: 1400px;
        margin: 40px auto;
        position: relative;
        .tech-title{
          font-size: 29px;
          line-height: 40px;
        }
        .tech-subtitle{
          font-size: 24px;
          color: #989898;
          line-height: 60px
        }
        .tech-detail{
          font-size: 18px;
          color: #989898;
          width: 66%;
          line-height: 30px;
          margin-top: 20px;
        }
        .tech-big{
          position: absolute;
          right: 0px;
          top: 30px;
          width: 28%;
        }
        .tech-one{
          background-color: #F3F3F5;
          text-align: center;
          padding: 6% 18%;
          margin-top: 50px;
          .tech-one-img{
            width: 80px;
            height: 80px;
            margin: 30px auto 40px;
          }
          .tech-one-title{
            font-weight: bold;
            font-size: 18px;
            color: #000;
          }
          .tech-one-con{
            font-size: 14px;
            color: #989898;
            text-align: left;
            line-height: 20px;
            margin-top: 20px;
            height: 100px;
          }
        }
      }
      .team-first-box{
        background-color: #fff;
        border-radius: 20px;
        max-width: 1400px;
        margin: 0 auto;
        .team-first-one{
          margin: 40px 0;
        }
        .left-box{
          position: relative;
          text-align: center;
          .team-img-bg{
            width: 240px;
            height: 240px;
            border-radius: 50%;
            // background-image: linear-gradient(to bottom, #A5E0FF, #EBF8FF);
            margin: 0 auto;
          }
          .team-user{
            position: absolute;
            top: 31px;
            left: 50%;
            width: 200px;
            height: 200px;
            margin-left: -100px;
          }
          .team-user-job-text{
            position: relative;
            margin: -44px auto 0px; 
            .team-text-bg{
              width: 220px;
              position: absolute;
              left: 22%;
              bottom: -30px;
            }
            .team-text-con{
              top: 4px;
              left: 12px;
              color: #fff;
              // z-index: 1000;
              position: relative;
            }
          }
        }
        .right-box{
          line-height: 26px;
          font-size: 14px;
          color: #989898;
          margin: 0 0;
          .job-box{
            color: #000;
            font-size: 20px;
            line-height: 31px;
            font-weight: bold;
          }
          .text-one{
            margin: 20px 0;
            text-align: justify;
          }
        }
        .long-light{
          width: 1400px;
          margin: 0 auto;
          height: 1px;
          background-color: #E5E9EA;
        }
        
      }
      .intel-box{
        max-width: 1400px;
        margin: 0 auto;
        background: url("./../../assets/honor/cup.png")no-repeat 50% 20%;
        .intel-one{
          text-align: center;
          margin: 100px 0;
          .intel-one-num{
            color: #989898;
            font-size: 50px;
            line-height: 70px;
          }
          .intel-one-unit{
            color: #989898 ;
            font-size: 20px;
          }
          .intel-one-text{
            font-size: 20px;
            font-weight: bold;
          }
        }
      }
      .intellectual{
        // padding: 60px 0 0;
        .intellectual-content{
          padding: 40px 0 0;
          max-width: 1400px;
          margin: 0 auto;
          .bannerList{
            max-width: 1400px;
            margin: 0 auto;
            overflow: hidden;
            border: 1px solid #f7f7f7;
            border-radius: 20px;
            .intel_prev,.intel_next,.honor_prev,.honor_next{
              background-color: #00D0FF;
              color: #fff;
            }
            .intel_prev:after,.intel_next:after,.honor_prev:after,.honor_next:after{
              font-size: 12px;
            }
            .intel_prev,.honor_prev{
              left: 0px;
            }
            .intel_next,.honor_next{
              right: 0px;
            }
          }

          .swipperItem{
            position: relative;
            text-align: left;
            padding: 10% 12%;
            cursor: default;
            .imgBox{
              border: 1px solid #a3a2a0;
              padding: 4px 6px;
              background: #fff;
              margin: 40px 0 0;
            }
            .honor-img{
              width: 100%;
              height: 218px;
            }
            .img-up-word{
              .img-up-word-content{
            //     margin: 203px 10px 0;
                font-size: 14px;
            //     text-align: right;
            //   }
            //   .img-up-word-dec{
            //     font-size: 14px;
            //     margin: 0 10px;
              }
            }
          }
          .swiper-pagination-intellectual{
            margin: 20px 0;
            text-align: center;
          }
          .swiper-pagination-honor{
            margin: 20px 0;
            text-align: center;
          }
          .intellectual-list{
            .intellectual-one{
              text-align: center;
              display: inline-block;
              width: 14%;
              .word{
                display: inline-block;
                .intellectual-word-big{
                  color: #171717;
                  font-size: 34px;
                  font-weight: bold;
                }
                .intellectual-word-small{
                  color: #161616;
                  font-size: 16px;
                }
                .intellectual-word-text{
                  color: #161616;
                  font-size: 16px;
                }
              }
              .gray{
                background: #d7d3d4;
                width: 2px;
                height: 48px;
                float: right;
                margin-top: 12px;
              }
            }
          }
        }
      }
    }
    .gain-m{
      .word{
        margin-top: 1rem;
        .word-title{
          font-size: 0.6rem;
          line-height: 1.2rem;
          text-align: center;
        }
        .word-text{
          line-height: 0.6rem;
          color: #9b9b9b;
          font-size: 0.4rem;
          text-align: center;
        }
      }
      .tech-box{
        max-width: 90%;
        margin: 0.8rem auto;
        position: relative;
        .tech-title{
          font-size: 0.4rem;
          line-height: 0.8rem;
        }
        .tech-subtitle{
          font-size: 0.36rem;
          color: #989898;
        }
        .tech-detail{
          font-size: 0.28rem;
          color: #989898;
          line-height: 0.48rem;
          margin-top: 0.4rem;
        }
        .tech-big{
          width: 100%;
        }
        .tech-one{
          background-color: #F3F3F5;
          text-align: center;
          padding: 0.4rem;
          margin-top: 1rem;
          .tech-one-img{
            width: 1.6rem;
            height: 1.6rem;
            margin: 0.6rem auto 0.4rem;
          }
          .tech-one-title{
            font-weight: bold;
            font-size: 0.36rem;
            color: #000;
          }
          .tech-one-con{
            font-size: 0.28rem;
            color: #989898;
            text-align: left;
            line-height: 0.4rem;
            margin-top: 0.4rem;
            height: 2rem;
          }
        }
      }
      .team-first-box{
        background-color: #fff;
        border-radius: 0.4rem;
        width: 90%;
        margin: 0 auto;
        .team-first-one{
          margin: 0.8rem 0;
        }
        .left-box{
          position: relative;
          text-align: center;
          .team-img-bg{
            width: 4rem;
            height: 4rem;
            border-radius: 50%;
            // background-image: linear-gradient(to bottom, #A5E0FF, #EBF8FF);
            margin: 0 auto;
          }
          .team-user{
            position: absolute;
            top: 0.3rem;
            left: 50%;
            width: 3.4rem;
            height: 3.4rem;
            margin-left: -1.6rem;
          }
          .team-user-job-text{
            position: relative;
            margin: -0.8rem auto 0; 
            .team-text-bg{
              width: 5rem;
            }
            .team-text-con{
              color: #fff;
              font-size: 0.34rem;
              text-align: center;
              margin-top: -1.2rem;
              margin-bottom: 1rem;
            }
          }
        }
        .right-box{
          line-height: 0.5rem;
          font-size: 0.28rem;
          color: #989898;
          margin: 0 0;
          .job-box{
            color: #000;
            font-size: 0.4rem;
            line-height: 0.6rem;
            font-weight: bold;
          }
          .text-one{
            margin: 0.4rem 0 0.2rem;
          }
        }
        .long-light{
          width: 90%;
          margin: 0 auto;
          height: 0.02rem;
          background-color: #E5E9EA;
        }
        
      }
      .intel-box{
        width: 90%;
        margin: 0 auto;
        background: url("./../../assets/honor/cup.png")no-repeat 50% 20%;
        background-size: 90% 80%;
        .intel-one{
          text-align: center;
          margin: 1.2rem 0;
          .intel-one-num{
            color: #989898;
            font-size: 1rem;
            line-height: 1.4rem;
          }
          .intel-one-unit{
            color: #989898 ;
            font-size: 0.4rem;
          }
          .intel-one-text{
            font-size: 0.4rem;
            font-weight: bold;
          }
        }
      }
      .intellectual{
        padding: 0 0 0;
        .intellectual-content{
          padding: 0.4rem 0 0.5rem;
          max-width: 90%;
          margin: 0 auto;
          .bannerList{
            max-width: 100%;
            margin: 0 auto;
            // overflow: hidden;
            border: 0.01rem solid #f7f7f7;
            border-radius: 0.4rem;
            .intel_prev,.intel_next,.honor_prev,.honor_next{
              background-color: #00D0FF;
              color: #fff;
            }
            .intel_prev:after,.intel_next:after,.honor_prev:after,.honor_next:after{
              font-size: 0.24rem;
            }
            .intel_prev,.honor_prev{
              left: 0;
            }
            .intel_next,.honor_next{
              right: 0;
            }
          }

          .swipperItem{
            position: relative;
            text-align: left;
            padding: 10% 12%;
            cursor: default;
            .imgBox{
              border: 0.01rem solid #a3a2a0;
              padding: 0.08rem 0.12rem;
              background: #fff;
              margin: 0.8rem 0 0;
            }
            .honor-img{
              width: 100%;
              height: 4rem;
            }
            .img-up-word{
              .img-up-word-content{
                font-size: 0.28rem;
              }
            }
          }
          .swiper-pagination-intellectual{
            margin: 0.4rem 0;
            text-align: center;
          }
          .swiper-pagination-honor{
            margin: 0.4rem 0;
            text-align: center;
          }
          .intellectual-list{
            .intellectual-one{
              text-align: center;
              display: inline-block;
              width: 14%;
              .word{
                display: inline-block;
                .intellectual-word-big{
                  color: #171717;
                  font-size: 0.6rem;
                  font-weight: bold;
                }
                .intellectual-word-small{
                  color: #161616;
                  font-size: 0.32rem;
                }
                .intellectual-word-text{
                  color: #161616;
                  font-size: 0.32rem;
                }
              }
              .gray{
                background: #d7d3d4;
                width: 0.04rem;
                height: 1rem;
                float: right;
                margin-top: 0.24rem;
              }
            }
          }
        }
      }
    }
  </style>
  